import styled from 'styled-components';

export const LabelWrapper = styled.div`
  display: flex;
  padding: 12px 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
`;

export const ClassCounter = styled.div`
  color: ${({ theme }) => theme.colors.black6};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  width: 100%;
  .ant-collapse {
    display: flex;
    flex-direction: column;
    gap: 8px;
    border: 1px solid ${({ theme }) => theme.colors.black3};
    border-radius: 8px;
    overflow: hidden;

    &:hover {
      border: 1px solid ${({ theme }) => theme.colors.black6};
    }
  }
  .ant-collapse-item {
    background: ${({ theme }) => theme.colors.white};
    border-radius: 0 !important;
  }

  .ant-collapse-header-text {
    color: ${({ theme }) => theme.colors.black9};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }

  .ant-collapse-header {
    align-items: center;
    background-color: ${({ theme }) => theme.colors.white};
    width: 100% !important;
    padding: 12px 16px !important;
    border-bottom: 1px solid ${({ theme }) => theme.colors.black3};
  }

  .ant-collapse-content-box {
    padding: 0 !important;
  }

  .ant-collapse-expand-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
